'use strict';

var angular = require('angular');

module.exports = function($scope, $rootScope, $http, $location, ngAudio) {
    var currentQuestion = null,
        isLastPage = false,
        isChainSelected = false,
        usedSprites = [];

    $scope.participant = {};
    $scope.showErrors = false;
    $scope.submitting = false;
    $scope.answer = [];
    $scope.buttonText = 'Neste';
    $scope.page = 'page';
    $scope.form = {};

    $scope.sound = {
        approve: ngAudio.load("/audio/cash-register.mp3"),
        deny: ngAudio.load("/audio/buzzer.mp3"),
        button: ngAudio.load("/audio/plop1.mp3"),
        button2: ngAudio.load("/audio/plop2.mp3"),
        button3: ngAudio.load("/audio/plop3.mp3"),
        click: ngAudio.load('/audio/click.mp3')
    };

    $http.get('/api/game/get-chains')
        .then(function(response) {
            $scope.chains = response.data;
        });

    /**
     * Go to the next question. If currently on a question, get this by answering
     * the current question.
     */
    $scope.next = function() {
        if (!isChainSelected) {
            $http.get('/api/participant')
                .then(function(response) {
                    $scope.participant = response.data.participant;
                    setupPage({showSelectChain: true, message: "Velg din kjede", alternatives: []});
                });

            return;
        }

        if (currentQuestion === null) {
            $http.get('/api/quiz/first-question')
                .then(function(response) {
                    setupPage(response.data);
                    currentQuestion = response.data.id;
                    $scope.buttonText = 'Neste';
                });

            return;
        }
        else if (isLastPage) {
            $location.path('/game');

            return;
        }

        $http.post('/api/quiz/answer', { answer: $scope.answer, question: currentQuestion })
            .then(function(response) {
                if (response.data.isLast) {
                    if (response.data.done) {
                        $scope.sound.button3.play();
                        isLastPage = true;
                        setupPage(response.data);
                        setSprite('/images/sprites/boss/happy.svg');
                        $scope.buttonText = 'Neste';
                    }
                    else {
                        $scope.sound.deny.volume = 0.6;
                        $scope.sound.deny.play();
                        return setupWrongAnswerPage(response.data);
                    }
                }
                else {
                    $scope.sound.button2.play();
                    setupPage(response.data);
                    currentQuestion = response.data.id;
                }
            });
    }

    $scope.toggleAlternative = function(index) {
        $scope.sound.click.volume = 0.5;
        $scope.sound.click.play();
        $scope.answer[index] = !($scope.answer[index] === true);
    }

    $scope.selectChainSubmit = function() {
        if ($scope.form.selectChainForm.$valid) {
            $scope.submitting = true;

            $http.post('/api/participant/save-chain', JSON.stringify($scope.participant))
                .then(function(response) {
                    $scope.submitting = false;
                    isChainSelected = true;
                    $scope.next();
               
                }, function(response) {
                    $scope.submitting = false;
                    $scope.showErrors = true;
                });
        }
        else {
            $scope.showErrors = true;
        }
    };

    /**
     * Set up a page with either a question or just info.
     */
    function setupPage(data) {
        $scope.message = data.message;
        $scope.title = data.title;
        $scope.question = data.question;
        $scope.alternatives = data.alternatives;
        $scope.answer = new Array(data.alternatives.length);
        $scope.showSelectChain = data.showSelectChain;

        setSprite(randomSprite());
        $scope.page = 'page';
    }

    /**
     *  Get a random sprite with small variations.
     */
    function randomSprite() {
        var sprites = ['default', 'point', 'show'],
            sprite = sprites[Math.floor(Math.random() * sprites.length)];

        return '/images/sprites/boss/' + sprite + '.svg';
    }

    var setSprite = function(url) {
        var postfix = '';

        if (usedSprites.indexOf(url) >= 0) {
            postfix = '?' + Math.random().toString(36).substring(7);
        }
        else {
            usedSprites.push(url);
        }

        $scope.sprite = url + postfix;
    };

    /**
     * Set up the first info page.
     */
    function setupFirstPage() {
        $http.get('/api/quiz/front-page')
            .then(function(response) {
                if (response.data.participantHash) {
                    $rootScope.participantHash = response.data.participantHash;
                }
                if (response.data.prequalified) {
                    $location.path('/game');
                }

                setupPage(response.data);
            }, function(response) {
                console.error('Could not get front page info.');
            });
    }

    /**
     * Set up the page for a wrong answer.
     */
    function setupWrongAnswerPage(data) {
        setupPage(data);
        $scope.buttonText = 'Rett opp feil';
        currentQuestion = null;

        setSprite('/images/sprites/boss/disappointed.svg');
        $scope.page = 'error';
    }

    setupFirstPage();
};
